import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.daggpt.network';

function decodeJWT(token) {
  try { return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); } catch { return null; }
}

export default function DebugAuthPage() {
  const [info, setInfo] = useState(null);
  const [serverUser, setServerUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('daggpt_token');
    const userRaw = localStorage.getItem('daggpt_user');
    const payload = token ? decodeJWT(token) : null;
    let cachedUser = null;
    try { cachedUser = userRaw ? JSON.parse(userRaw) : null; } catch {}

    setInfo({ token: token ? token.substring(0, 40) + '...' : null, payload, cachedUser });

    if (token) {
      fetch(`${API}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(d => setServerUser(d?.user || null))
        .catch(() => setServerUser('FETCH_ERROR'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const row = (label, value, highlight) => (
    <div style={{ padding: '10px 0', borderBottom: '1px solid #e5e7eb' }}>
      <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 3 }}>{label}</div>
      <div style={{ fontSize: 14, color: highlight ? '#dc2626' : '#111827', fontWeight: highlight ? 700 : 400, wordBreak: 'break-all' }}>
        {value === null ? <em style={{ color: '#9ca3af' }}>null</em> : JSON.stringify(value)}
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: 20, fontFamily: 'monospace' }}>
      <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>🔍 Auth Debug</h1>
      <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 20 }}>This page shows your current auth state. Share a screenshot.</p>

      <div style={{ background: '#fff', borderRadius: 12, padding: '0 16px', border: '1px solid #e5e7eb', marginBottom: 16 }}>
        <div style={{ padding: '12px 0 6px', fontSize: 12, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: 1 }}>Token in localStorage</div>
        {row('Token (first 40 chars)', info?.token)}
        {row('Token → sub (User ID)', info?.payload?.sub)}
        {row('Token → email', info?.payload?.email)}
        {row('Token → exp', info?.payload?.exp ? new Date(info.payload.exp * 1000).toISOString() : null)}
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: '0 16px', border: '1px solid #e5e7eb', marginBottom: 16 }}>
        <div style={{ padding: '12px 0 6px', fontSize: 12, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: 1 }}>Cached User (localStorage)</div>
        {row('full_name', info?.cachedUser?.full_name, info?.cachedUser?.full_name === 'Hari Rahul')}
        {row('email', info?.cachedUser?.email)}
        {row('id', info?.cachedUser?.id)}
      </div>

      <div style={{ background: '#fff', borderRadius: 12, padding: '0 16px', border: '1px solid #e5e7eb', marginBottom: 16 }}>
        <div style={{ padding: '12px 0 6px', fontSize: 12, fontWeight: 700, color: '#374151', textTransform: 'uppercase', letterSpacing: 1 }}>
          Server Response (/api/auth/me) {loading && '⏳'}
        </div>
        {!loading && <>
          {row('full_name', serverUser?.full_name, serverUser?.full_name === 'Hari Rahul')}
          {row('email', serverUser?.email)}
          {row('id', serverUser?.id)}
        </>}
      </div>

      <button onClick={() => {
        localStorage.clear();
        window.location.href = '/';
      }} style={{
        width: '100%', padding: '14px', borderRadius: 12, border: 'none',
        background: '#dc2626', color: '#fff', fontSize: 14, fontWeight: 700, cursor: 'pointer'
      }}>
        🗑️ Clear All Storage &amp; Go Home
      </button>
    </div>
  );
}
